// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.7
//   protoc               unknown
// source: qonto/transfers/api/transfers/firstparty/v4/activity_tag.proto

/* oxlint-disable */

/** Represents an activity tag for categorizing transactions */
export const ApiActivityTag = {
  /** ACTIVITY_TAG_UNSPECIFIED - Default unspecified value */
  ACTIVITY_TAG_UNSPECIFIED: "ACTIVITY_TAG_UNSPECIFIED",
  /**
   * Restaurant and bar expenses
   */
  restaurant_and_bar: "restaurant_and_bar",
  /**
   * Food and grocery purchases
   */
  food_and_grocery: "food_and_grocery",
  /**
   * Transport and travel expenses
   */
  transport: "transport",
  /**
   * Gas station purchases
   */
  gas_station: "gas_station",
  /**
   * Hotel and lodging expenses
   */
  hotel_and_lodging: "hotel_and_lodging",
  /**
   * IT and electronics purchases
   */
  it_and_electronics: "it_and_electronics",
  /**
   * Hardware and equipment purchases
   */
  hardware_and_equipment: "hardware_and_equipment",
  /**
   * Office supply expenses
   */
  office_supply: "office_supply",
  /**
   * Office rental expenses
   */
  office_rental: "office_rental",
  /**
   * Utility expenses (electricity, water, etc.)
   */
  utility: "utility",
  /**
   * Insurance expenses
   */
  insurance: "insurance",
  /**
   * Logistics and shipping expenses
   */
  logistics: "logistics",
  /**
   * Online service subscriptions and expenses
   */
  online_service: "online_service",
  /**
   * Legal and accounting services
   */
  legal_and_accounting: "legal_and_accounting",
  /**
   * Finance-related expenses
   */
  finance: "finance",
  /**
   * Tax payments
   */
  tax: "tax",
  /**
   * Salary payments
   */
  salary: "salary",
  /**
   * Marketing and advertising expenses
   */
  marketing: "marketing",
  /**
   * Manufacturing expenses
   */
  manufacturing: "manufacturing",
  /**
   * ATM withdrawals
   */
  atm: "atm",
  /**
   * Other service expenses
   */
  other_service: "other_service",
  /**
   * Other miscellaneous expenses
   */
  other_expense: "other_expense",
  /**
   * Treasury and intercompany transactions
   */
  treasury_and_interco: "treasury_and_interco",
  /**
   * Sales revenue
   */
  sales: "sales",
  /**
   * Other income
   */
  other_income: "other_income",
  /**
   * Refunds received
   */
  refund: "refund",
  /**
   * Bank and service fees
   */
  fees: "fees",
  /**
   * Subscription payments
   */
  subscription: "subscription",
  /**
   * Voucher redemptions
   */
  voucher: "voucher",
  /**
   * Direct debit hold
   */
  direct_debit_hold: "direct_debit_hold",
  /**
   * Fallback category for uncategorized transactions
   */
  fallback: "fallback",
} as const;

export type ApiActivityTag = typeof ApiActivityTag[keyof typeof ApiActivityTag];

export namespace ApiActivityTag {
  export type ACTIVITY_TAG_UNSPECIFIED = typeof ApiActivityTag.ACTIVITY_TAG_UNSPECIFIED;
  export type restaurant_and_bar = typeof ApiActivityTag.restaurant_and_bar;
  export type food_and_grocery = typeof ApiActivityTag.food_and_grocery;
  export type transport = typeof ApiActivityTag.transport;
  export type gas_station = typeof ApiActivityTag.gas_station;
  export type hotel_and_lodging = typeof ApiActivityTag.hotel_and_lodging;
  export type it_and_electronics = typeof ApiActivityTag.it_and_electronics;
  export type hardware_and_equipment = typeof ApiActivityTag.hardware_and_equipment;
  export type office_supply = typeof ApiActivityTag.office_supply;
  export type office_rental = typeof ApiActivityTag.office_rental;
  export type utility = typeof ApiActivityTag.utility;
  export type insurance = typeof ApiActivityTag.insurance;
  export type logistics = typeof ApiActivityTag.logistics;
  export type online_service = typeof ApiActivityTag.online_service;
  export type legal_and_accounting = typeof ApiActivityTag.legal_and_accounting;
  export type finance = typeof ApiActivityTag.finance;
  export type tax = typeof ApiActivityTag.tax;
  export type salary = typeof ApiActivityTag.salary;
  export type marketing = typeof ApiActivityTag.marketing;
  export type manufacturing = typeof ApiActivityTag.manufacturing;
  export type atm = typeof ApiActivityTag.atm;
  export type other_service = typeof ApiActivityTag.other_service;
  export type other_expense = typeof ApiActivityTag.other_expense;
  export type treasury_and_interco = typeof ApiActivityTag.treasury_and_interco;
  export type sales = typeof ApiActivityTag.sales;
  export type other_income = typeof ApiActivityTag.other_income;
  export type refund = typeof ApiActivityTag.refund;
  export type fees = typeof ApiActivityTag.fees;
  export type subscription = typeof ApiActivityTag.subscription;
  export type voucher = typeof ApiActivityTag.voucher;
  export type direct_debit_hold = typeof ApiActivityTag.direct_debit_hold;
  export type fallback = typeof ApiActivityTag.fallback;
}

export function apiActivityTagFromJSON(object: any): ApiActivityTag {
  switch (object) {
    case 0:
    case "ACTIVITY_TAG_UNSPECIFIED":
      return ApiActivityTag.ACTIVITY_TAG_UNSPECIFIED;
    case 1:
    case "restaurant_and_bar":
      return ApiActivityTag.restaurant_and_bar;
    case 2:
    case "food_and_grocery":
      return ApiActivityTag.food_and_grocery;
    case 3:
    case "transport":
      return ApiActivityTag.transport;
    case 4:
    case "gas_station":
      return ApiActivityTag.gas_station;
    case 5:
    case "hotel_and_lodging":
      return ApiActivityTag.hotel_and_lodging;
    case 6:
    case "it_and_electronics":
      return ApiActivityTag.it_and_electronics;
    case 7:
    case "hardware_and_equipment":
      return ApiActivityTag.hardware_and_equipment;
    case 8:
    case "office_supply":
      return ApiActivityTag.office_supply;
    case 9:
    case "office_rental":
      return ApiActivityTag.office_rental;
    case 10:
    case "utility":
      return ApiActivityTag.utility;
    case 11:
    case "insurance":
      return ApiActivityTag.insurance;
    case 12:
    case "logistics":
      return ApiActivityTag.logistics;
    case 13:
    case "online_service":
      return ApiActivityTag.online_service;
    case 14:
    case "legal_and_accounting":
      return ApiActivityTag.legal_and_accounting;
    case 15:
    case "finance":
      return ApiActivityTag.finance;
    case 16:
    case "tax":
      return ApiActivityTag.tax;
    case 17:
    case "salary":
      return ApiActivityTag.salary;
    case 18:
    case "marketing":
      return ApiActivityTag.marketing;
    case 19:
    case "manufacturing":
      return ApiActivityTag.manufacturing;
    case 20:
    case "atm":
      return ApiActivityTag.atm;
    case 21:
    case "other_service":
      return ApiActivityTag.other_service;
    case 22:
    case "other_expense":
      return ApiActivityTag.other_expense;
    case 23:
    case "treasury_and_interco":
      return ApiActivityTag.treasury_and_interco;
    case 24:
    case "sales":
      return ApiActivityTag.sales;
    case 25:
    case "other_income":
      return ApiActivityTag.other_income;
    case 26:
    case "refund":
      return ApiActivityTag.refund;
    case 27:
    case "fees":
      return ApiActivityTag.fees;
    case 28:
    case "subscription":
      return ApiActivityTag.subscription;
    case 29:
    case "voucher":
      return ApiActivityTag.voucher;
    case 30:
    case "direct_debit_hold":
      return ApiActivityTag.direct_debit_hold;
    case 31:
    case "fallback":
      return ApiActivityTag.fallback;
    default:
      return ApiActivityTag.ACTIVITY_TAG_UNSPECIFIED;
  }
}

export function apiActivityTagToJSON(object: ApiActivityTag): string {
  switch (object) {
    case ApiActivityTag.ACTIVITY_TAG_UNSPECIFIED:
      return "ACTIVITY_TAG_UNSPECIFIED";
    case ApiActivityTag.restaurant_and_bar:
      return "restaurant_and_bar";
    case ApiActivityTag.food_and_grocery:
      return "food_and_grocery";
    case ApiActivityTag.transport:
      return "transport";
    case ApiActivityTag.gas_station:
      return "gas_station";
    case ApiActivityTag.hotel_and_lodging:
      return "hotel_and_lodging";
    case ApiActivityTag.it_and_electronics:
      return "it_and_electronics";
    case ApiActivityTag.hardware_and_equipment:
      return "hardware_and_equipment";
    case ApiActivityTag.office_supply:
      return "office_supply";
    case ApiActivityTag.office_rental:
      return "office_rental";
    case ApiActivityTag.utility:
      return "utility";
    case ApiActivityTag.insurance:
      return "insurance";
    case ApiActivityTag.logistics:
      return "logistics";
    case ApiActivityTag.online_service:
      return "online_service";
    case ApiActivityTag.legal_and_accounting:
      return "legal_and_accounting";
    case ApiActivityTag.finance:
      return "finance";
    case ApiActivityTag.tax:
      return "tax";
    case ApiActivityTag.salary:
      return "salary";
    case ApiActivityTag.marketing:
      return "marketing";
    case ApiActivityTag.manufacturing:
      return "manufacturing";
    case ApiActivityTag.atm:
      return "atm";
    case ApiActivityTag.other_service:
      return "other_service";
    case ApiActivityTag.other_expense:
      return "other_expense";
    case ApiActivityTag.treasury_and_interco:
      return "treasury_and_interco";
    case ApiActivityTag.sales:
      return "sales";
    case ApiActivityTag.other_income:
      return "other_income";
    case ApiActivityTag.refund:
      return "refund";
    case ApiActivityTag.fees:
      return "fees";
    case ApiActivityTag.subscription:
      return "subscription";
    case ApiActivityTag.voucher:
      return "voucher";
    case ApiActivityTag.direct_debit_hold:
      return "direct_debit_hold";
    case ApiActivityTag.fallback:
      return "fallback";
    default:
      return "ACTIVITY_TAG_UNSPECIFIED";
  }
}
